@if (!permissionAsked) {
  <div class="notify-toast">
    <svg class="notify-toast__icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>
    <span class="notify-toast__text">Bật thông báo cuộc gọi từ bác sĩ</span>
    <button class="notify-toast__btn" (click)="enableNotifications()" type="button">Bật</button>
    <button class="notify-toast__dismiss" (click)="permissionAsked = true" type="button" aria-label="Đóng">
      <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>
}

<div class="main-container">
  <router-outlet></router-outlet>
</div>

@if (isCallActive && currentCallData) {
  <app-video-call
    [isCallActive]="isCallActive"
    [receiverUid]="currentCallData.clientUid || ''"
    [receiverEmail]="currentCallData.clientEmail || ''">
  </app-video-call>
}
